export function themeCookie() {
  // eslint-disable-next-line
  console.log(themePaths);

  window.cookieconsent.initialise({
    container: document.getElementById('cookie-law'),
    'palette': {
      'popup': {
        'background': '#091337',
        'text': '#fff',
      },
      'button': {
        'background': '#C549B5',
        'text': '#fff',
      },
    },
    'content': {
      // eslint-disable-next-line
      'href': themePaths.privacy_page,
    },
   });
}
